export const MIDDLE_EAST_COUNTRY_CODES = ["AZ", "BH", "JO", "KW", "LB", "OM", "QA", "SA", "AE"];
